<apx-chart *ngIf="chartOptions?.series?.length && chartOptions?.labels?.length" #chart
    style="height: 100%; display:block;" [series]="chartOptions.series" [chart]="chartOptions.chart"
    [labels]="chartOptions.labels" [legend]="chartOptions.legend" [responsive]="chartOptions.responsive"
    [colors]="chartOptions.colors">
</apx-chart>